import { z } from 'zod'

export const overrideApproverSchema = z.enum(['manager', 'director', 'hr'])
export type OverrideApprover = z.infer<typeof overrideApproverSchema>

export const teamSchema = z.object({
  id: z.guid(),
  name: z.string().min(1),
  members: z.number().int().nonnegative(),
  slotPct: z.number().int().min(1).max(100),
  managerId: z.guid().nullable(),
  /** Minimum absolute headcount that must be present; null = use pct cap only. */
  floor: z.number().int().nonnegative().nullable(),
  /** Role names that trigger escalation when absent; null = none designated. */
  criticalRoles: z.array(z.string()).nullable(),
  /** Which approval tier can grant a cap override; null = system default (director). */
  overrideApprover: overrideApproverSchema.nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type Team = z.infer<typeof teamSchema>

export const teamCreateSchema = teamSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export type TeamCreate = z.infer<typeof teamCreateSchema>
